import { CInvoicingPriceWithTaxType } from "../types";

export class CInvoicingPriceWithTax {
  constructor(json: CInvoicingPriceWithTaxType) {
    Object.assign(this, json);
  }

  withTax: number;

  withoutTax: number;

  taxAmount: number;
}
